export class JustAddPowerAmp {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.3.5 (January 11, 2023)';
        this.numVideoInputs = 8;
        this.numVideoOutputs = 16;
        this.videoOutputs = Array(17).fill('1');
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /jpsw -v/i,
                callback: (match) => {
                    this.socket.send(`/usr/local/bin # ${match[0]}`); // Command echo
                    this.socket.send(`jpsw ${this.firmwareVersion}`);
                },
            },
            {
                name: 'matrixRoute',
                regExp: /jpsw -r (\d+) -t (\d+)/i,
                callback: (match) => {
                    const input = parseInt(match[2], 10);
                    this.videoOutputs[input] = match[1];
                    this.socket.send(`/usr/local/bin # ${match[0]}`); // Command echo
                    this.socket.send(`${match[2]}:${match[1]}`);
                },
            },
            {
                name: 'matrixSize',
                regExp: /jpsw -c/i,
                callback: (match) => {
                    this.socket.send(`/usr/local/bin # ${match[0]}`); // Command echo
                    this.socket.send(`${this.numVideoInputs}x${this.numVideoOutputs}/1`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`/usr/local/bin # ${match[0]}`); // Command echo
                    this.socket.send(`CMD ERR`);
                },
            },
        ];
    }
}
JustAddPowerAmp.emulatorType = 'socketEmulator';
JustAddPowerAmp.key = '-NNmhnsG3c299Z3Ylqia';
